import {
  CLARITY_API_KEY,
  GOOGLE_ANALYTICS_GA4_APPID,
  GTM_SCRIPT_ID,
  SWAGMAGIC_GTM_SCRIPT_ID,
  SWAGMAGIC_GOOGLE_ANALYTICS_GA4_APPID,
  SWAGMAGIC_CLARITY_API_KEY,
} from "@constants/env-variables";

export const BYSTADIUM_ANALYTICS_SERVICES = {
  gtm: GTM_SCRIPT_ID,
  ga4: GOOGLE_ANALYTICS_GA4_APPID,
  clarity: CLARITY_API_KEY,
};

export const SWAGMAGIC_ANALYTICS_SERVICES = {
  gtm: SWAGMAGIC_GTM_SCRIPT_ID,
  ga4: SWAGMAGIC_GOOGLE_ANALYTICS_GA4_APPID,
  clarity: SWAGMAGIC_CLARITY_API_KEY,
};
